import { ReactNode } from "react";
import {
	SignedIn,
	SignedOut,
	RedirectToSignIn,
} from "@/components/SafeClerkComponents";

// Gates a page behind authentication, redirecting signed-out users to
// sign-in — restoring the old Next middleware behavior (every non-public
// path required sign-in). Respects the dev bypass via SafeClerkComponents.
export function RequireAuth({ children }: { children: ReactNode }) {
	return (
		<>
			<SignedIn>{children}</SignedIn>
			<SignedOut>
				<RedirectToSignIn />
			</SignedOut>
		</>
	);
}

export default RequireAuth;
